var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"configurator-main-title",attrs:{"id":_vm.id}},[_c('h1',[(_vm.titleHead)?_c('span',[_vm._v(_vm._s(_vm.titleHead)),_c('br')]):_vm._e(),_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }